/* eslint-disable no-console */
import { Box, FormControl } from '@chakra-ui/react';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { ConcentrationCalcFieldLabel } from './ConcentrationCalcFieldLabel';
import { FieldSelector, mapFieldType } from './FieldSelector';

export const ExposureByGroupConfigEditor = ({
  availableFields,
  value,
  onChange,
}: {
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[];
  value: CreditAgreement.Config.ConcentrationLimit.Calculation.DeclarativeFilterEligibleExposureBySingleFieldCalculationConfig;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.DeclarativeFilterEligibleExposureBySingleFieldCalculationConfig,
  ) => void;
}) => {
  console.log(onChange, value);

  const setField = (field: string) => {
    const type = mapFieldType(field, availableFields);
    finleyAssert(type !== 'boolean', 'boolean type not supported');
    const fieldType = type === 'string' ? 'string' : 'integer';
    onChange({
      ...value,
      config: {
        ...value.config,
        groupingField: field,
        fieldType,
      },
    });
  };

  return (
    <Box p={1}>
      <FormControl>
        <ConcentrationCalcFieldLabel
          m={1}
          label="Group by field"
          tooltip="receivables will be grouped by this field. and standard concetration limit will be applied to each group"
        />
        <FieldSelector
          availableFields={availableFields}
          allowedTypes={['string', 'integer']}
          initialField={value.config.groupingField}
          onSelectedFieldChange={(field) => setField(field)}
        />
      </FormControl>
    </Box>
  );
};
